import { DragOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { useTranslation } from 'react-i18next'

import { PureInput } from '../../../../../common/ui/pure-input/pure-input'

type SeqWorkspaceItemProps = {
  id: number
  text: string
  estimation: number
  onEstimationChanged?: (milestoneId: number, estimation: number) => void
}

export const SeqWorkspaceItem = ({ id, text, estimation, onEstimationChanged }: SeqWorkspaceItemProps) => {
  const { t } = useTranslation()

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id }) // Передаем уникальный id элемента

  const style: any = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '16px',
    margin: '8px 0',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: isDragging ? '#e2e8f0' : '#ffffff',
    border: '1px solid #cbd5e1',
    borderRadius: '6px',
    boxShadow: isDragging ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 'none',
    userSelect: 'none',
    opacity: isDragging ? 0.6 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <div className="d-flex flex-column">
        <b>{text}</b>
        <PureInput
          label={t('workspace.setEstimation')}
          onChange={(e) => onEstimationChanged?.(id, Number(e.currentTarget.value))}
          required={false}
          size="small"
          type="number"
          value={estimation}
        />
      </div>
      <DragOutlined
        {...listeners}
        style={{ cursor: 'grab', alignSelf: 'center' }}
      />
    </div>
  )
}
